var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.999,
    height: 11.042,
    viewBox: "0 0 10.999 11.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "incoming.svg",
    d: "M90.537,181.828a.554.554,0,0,0-.784,0l-8.641,8.637v-4.748a.569.569,0,0,0-.472-.566.556.556,0,0,0-.639.55v6.109a.557.557,0,0,0,.556.555H86.1a.569.569,0,0,0,.567-.472.556.556,0,0,0-.55-.639H81.9l8.641-8.638A.559.559,0,0,0,90.537,181.828Z",
    transform: "translate(-79.85 -181.473)",
    fill: "#44bf3d",
    stroke: "#44bf3d",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoming);
export default __webpack_public_path__ + "static/media/incoming.5348546c.svg";
export { ForwardRef as ReactComponent };